// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3b8rx","location":"Header_location__2kRfR"};